
    (() => {
      const header = document.getElementById('siteHeader');
      const isHome = !document.querySelector('.sx-solid');
      const updateHeader = () => header.classList.toggle('is-sticky', isHome && window.scrollY > 70);
      window.addEventListener('scroll', updateHeader, {passive:true});
      updateHeader();

      const toggle = document.getElementById('menuToggle');
      const mobile = document.getElementById('mobileMenu');
      const closeMenu = () => { mobile.classList.remove('is-open'); toggle.setAttribute('aria-expanded','false'); toggle.setAttribute('aria-label','Open menu'); };
      toggle.addEventListener('click', () => {
        const open = !mobile.classList.contains('is-open');
        mobile.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
      mobile.querySelectorAll('a').forEach(link => link.addEventListener('click',closeMenu));
      document.addEventListener('keydown', e => { if(e.key === 'Escape') closeMenu(); });

      const kits = {
        day: {category:'FIELD GUIDE / 01', title:'THE DAY-TRIP<br>ESSENTIALS.', description:'The basics worth thinking through before you hit the trail.', items:['Reliable light source','Water and weather-appropriate layers','Navigation and a charged phone','Basic first-aid supplies']},
        weekend: {category:'FIELD GUIDE / 02', title:'THE WEEKEND<br>SETUP.', description:'Prepare for a couple of nights away, and check your conditions before departure.', items:['Shelter and sleep setup','Lighting and backup power','Water, food and a way to prepare them','Navigation, layers and first-aid supplies']},
        ready: {category:'FIELD GUIDE / 03', title:'THE READY<br>ESSENTIALS.', description:'A simple starting point for thinking through your household backup supplies.', items:['Flashlight and spare batteries','Drinking water and shelf-stable food','First-aid kit and essential medication','Communication plan and key documents']}
      };
      const tabs = [...document.querySelectorAll('[data-kit]')];
      const selectKit = name => {
        const kit = kits[name]; if(!kit) return;
        document.getElementById('kitCategory').textContent = kit.category;
        document.getElementById('kitTitle').innerHTML = kit.title;
        document.getElementById('kitDescription').textContent = kit.description;
        document.getElementById('kitList').replaceChildren(...kit.items.map(item => {
          const li = document.createElement('li'); li.textContent = item; return li;
        }));
        tabs.forEach(tab => { const active = tab.dataset.kit === name; tab.setAttribute('aria-selected',String(active)); tab.tabIndex = active ? 0 : -1; });
        document.getElementById('kitPanel').setAttribute('aria-labelledby', 'tab-' + name);
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click',()=>selectKit(tab.dataset.kit));
        tab.addEventListener('keydown',e=>{
          if(e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const next=tabs[(index+(e.key==='ArrowRight'?1:tabs.length-1))%tabs.length];
          selectKit(next.dataset.kit); next.focus();
        });
      });
      
    })();
  